import { render, staticRenderFns } from "./FormContainer.vue?vue&type=template&id=2d73797e&scoped=true"
import script from "./FormContainer.vue?vue&type=script&lang=js"
export * from "./FormContainer.vue?vue&type=script&lang=js"
import style0 from "./FormContainer.vue?vue&type=style&index=0&id=2d73797e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d73797e",
  null
  
)

export default component.exports